import React from 'react';
import SEOHead from '../components/SEOHead';
import HeroSection from '../components/HeroSection';
import IndustrialComparisonSection from '../components/IndustrialComparisonSection';
import ContactSection from '../components/ContactSection';

const HomePage = () => {
  return (
    <>
      <SEOHead 
        title="Gegadyne Energy | Multi-Ion™ Industrial Batteries | Traction, ESS & Ground Power Systems"
        description="Leading industrial battery manufacturer in India. Multi-Ion traction batteries for forklifts, cranes & warehouses. Energy storage systems for commercial, industrial & residential. 15-min fast charging, 5000+ cycles. Made in India."
        keywords="battery manufacturer India, industrial battery India, traction battery, forklift battery India, crane battery, ESS battery India, energy storage systems India, fast charging battery, Multi-Ion battery"
        canonicalPath="/"
      />
      <HeroSection />
      <IndustrialComparisonSection />
      <ContactSection />
    </>
  );
};

export default HomePage;
